<template>
  <b-card
    class="card card-congratulations"
  >
    <div>
      <h5 class="text-white text-capitalize">
        <span style="font-size:24px;"> {{ $t('Hi') }} {{ userData ? `${userData.firstname},` : null }}</span>

      </h5>
      <b-card-text
        style="font-size:17px;"
        class="text-white"
      >
        {{ $t('It\'s good to see you again.') }}
      </b-card-text>

    </div>

    <feather-icon
      icon="UserIcon"
      size="100"
      class="congratulation-medal mt-1 text-white"
    />

    <b-card-text class="font-small-4 text-white d-md-none last-login-bottom mb-0">
      {{ $t('Your last login time was') }} : {{ lastLoginDate }}
    </b-card-text>
  </b-card>
</template>

<script>
import { kFormatter } from '@core/utils/filter'
import {
  BCard, BCardText,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { mapGetters } from 'vuex'
import { toDateWithCustomTime } from '@/helpers/formatDate'

export default {
  components: {
    BCard,
    BCardText,
  },
  directives: {
    Ripple,
  },
  computed: {
    ...mapGetters({
      userData: 'auth/getCurrentUser',
    }),
    lastLoginDate() {
      if (this.userData && this.userData.lastLoginDate) {
        return toDateWithCustomTime(this.userData.lastLoginDate)
      }
      return null
    },
  },
  methods: {
    kFormatter,
  },
}
</script>

<style scoped>
.last-login-bottom {
  padding-top: 82px;
}
</style>
